import styled from 'styled-components'

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const LensSelectWrap = styled.div`
  min-width: 160px;
`

export const SearchWrapper = styled.div`
  flex: 1;
  min-width: 240px;
  max-width: 480px;
`

export const ToolbarToggleControl = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  cursor: pointer;
`
